import { api } from '../configs/apiConfig';

const WorkflowAssignmentService = {
    getAll: async () => {
        try {
            const response = await api.get('/WorkflowAssignment');
            return response.data;
        } catch (error) {
            console.error('Error fetching workflow assignments:', error);
            throw error;
        }
    },

    getAllAssignments: async () => {
        return WorkflowAssignmentService.getAll();
    },

    getById: async (id) => {
        try {
            const response = await api.get(`/WorkflowAssignment/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching workflow assignment ${id}:`, error);
            throw error;
        }
    },

    getAssignmentById: async (id) => {
        return WorkflowAssignmentService.getById(id);
    },

    getByWorkflowId: async (workflowId) => {
        try {
            const response = await api.get(`/WorkflowAssignment/workflow/${workflowId}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching workflow assignments for workflow ${workflowId}:`, error);
            throw error;
        }
    },

    create: async (assignmentData) => {
        try {
            const response = await api.post('/WorkflowAssignment', assignmentData);
            return response.data;
        } catch (error) {
            console.error('Error creating workflow assignment:', error);
            throw error;
        }
    },

    createAssignment: async (assignmentData) => {
        return WorkflowAssignmentService.create(assignmentData);
    },

    update: async (id, assignmentData) => {
        try {
            const response = await api.put(`/WorkflowAssignment/${id}`, assignmentData);
            return response.data;
        } catch (error) {
            console.error(`Error updating workflow assignment ${id}:`, error);
            throw error;
        }
    },

    updateAssignment: async (id, assignmentData) => {
        return WorkflowAssignmentService.update(id, assignmentData);
    },

    delete: async (id) => {
        try {
            await api.delete(`/WorkflowAssignment/${id}`);
            return true;
        } catch (error) {
            console.error(`Error deleting workflow assignment ${id}:`, error);
            throw error;
        }
    },

    deleteAssignment: async (id) => {
        return WorkflowAssignmentService.delete(id);
    },

    getWorkflowForProcess: async (processTypeName, userId) => {
        try {
            const response = await api.get('/WorkflowAssignment/process-workflow', {
                params: { processTypeName, userId }
            });
            return response.data;
        } catch (error) {
            console.error('Error getting workflow for process:', error);
            throw error;
        }
    }
};

export default WorkflowAssignmentService;